<!-- 保单信息 -->
<template>
  <div>
    <!-- @submit="handleSubmitjyb" -->
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="起止日期">
        <a-date-picker
          :disabled-date="disabledDate"
          :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          placeholder="开始日期"
          :disabled="userBol"
          v-decorator="[
            'baodanData.startdata',
            { rules: [{ required: true, message: '请选择起始日期！' }] },
          ]"
          @change="effectiveDateChange"
        />
        <a-date-picker
          :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
          style="margin-left: 20px"
          disabled
          placeholder="结束日期"
          v-model="applicantInfoExpireDate"
        />
        <span style="margin-left: 24px" v-if="planOffsetDay > 0">共{{ planOffsetDay }}天</span>
        <a-radio-group v-model="mon" @change="onChangemon">
          <a-radio
            :disabled="userBol"
            v-for="item in guarantPre"
            :key="item.key"
            :value="item.key"
          >{{ item.value }}</a-radio>
        </a-radio-group>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="投保企业名称">
        <a-input
          v-model="applicantInfo.name"
          :disabled="userBol"
          v-decorator="[
            'applicantInfo.name',
            { rules: [{ required: true, message: '请输入投保企业名称' }] },
          ]"
          placeholder="请输入投保企业名称"
          @blur="queryCompanyCodeByName()"
        ></a-input>
      </a-form-item>
      <p style="color: red">①江苏省-苏州市-常熟市及张家港市地区的企业团体，仅限投保1-2类职业。②不承保广东江门市家具制造业。③不承保天津地址所有企业。</p>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select
              :disabled="userBol"
              @change="(value) => handleChange(value, 'idType')"
              v-decorator="[
                'applicantInfo.idType',
                {
                  rules: [
                    { required: true, message: '请选择投保企业证件类型' },
                  ],
                },
              ]"
              placeholder="请选择投保企业证件类型"
            >
              <a-select-option
                v-for="item in companyIdTypeOptions"
                :key="item.value"
                :value="item.value"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
            <a-input
              :disabled="userBol"
              v-model="applicantInfo.idNumber"
              v-decorator="[
                'applicantInfo.idNumber',
                {
                  rules: [
                    { required: true, message: '请输入投保企业证件号码' },
                  ],
                },
              ]"
              placeholder="请输入投保企业证件号码"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="24">
          <a-form-item :label-col="{ span: 3 }" label="行业类别">
            <a-cascader
              :options="industryList"
              :field-names="{ label: 'text' }"
              :disabled="RiskInfos.architecture == 1||userBol"
              :show-search="{ filter }"
              @change="
                (value, label) => handleChange(value, 'industrycode', label)
              "
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }"
              v-decorator="[
                'applicantInfo.industrycode',
                { rules: [{ required: true, message: '请选择' }] },
              ]"
              placeholder="请选择行业"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-form-item :label-col="{ span: 3 }" label="联系地址">
          <a-col :span="12">
            <a-cascader
              placeholder="请选择"
              :disabled="userBol"
              @change="(value, label) => handleChange(value, 'pacCode', label)"
              v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }],
                },
              ]"
              :options="addressOptions"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }"
              style="float: left; width: 250px"
            />
          </a-col>
          <a-col :span="12">
            <a-input
              v-model="applicantInfo.address"
              :disabled="userBol"
              v-decorator="[
                'applicantInfo.address',
                {
                  rules: [{ required: true, message: '请输入联系地址' }],
                },
              ]"
              placeholder="请输入联系地址"
              style="float: left; width: 350px; margin-left: 10px"
            ></a-input>
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人姓名">
            <a-input
              :disabled="userBol"
              v-model="applicantInfo.contactsname"
              v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入企业联系人姓名' }],
                },
              ]"
              placeholder="请输入企业联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人电话">
            <a-input
              :disabled="userBol"
              v-model="applicantInfo.contactsphone"
              @blur="idPhoneChange"
              v-decorator="[
                'applicantInfo.contactsphone',
                {
                  rules: [{ required: true, message: '请输入企业联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' }],
                },
              ]"
              placeholder="请输入企业联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人邮箱">
            <a-input
              :disabled="userBol"
              v-model="applicantInfo.email"
              @blur="emailChange"
              v-decorator="[
                'applicantInfo.email',
                {
                  rules: [{ required: true, message: '请输入企业联系人邮箱' },
                  { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }],
                },
              ]"
              placeholder="请输入企业联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="支付方式">
            <a-select
              :disabled="userBol"
              @change="(value) => handleChange(value, 'payMethod')"
              style="width: 133px"
              placeholder="请选择支付方式"
              v-decorator="[
                'applicantInfo.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付方式' }],
                },
              ]"
            >
              <a-select-option
                v-for="item in payTypeList"
                :key="item.value"
                :value="item.value"
              >{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <!-- <a-row :gutter="24">
        <a-form-item :label-col="{ span: 3 }" label="保单备注" style="padding: 0 12px">
          <a-input
            :disabled="userBol"
            v-model="applicantInfo.remark"
            v-decorator="['applicantInfo.remark']"
            placeholder="请输入备注"
          ></a-input>
        </a-form-item>
      </a-row> -->
      <salInsuredList
        :columns="columns"
        :data="data"
        @delSelect="delSelectpre"
        @addSelect="addSelectpre"
        @EduitSelect="EduitSelect"
      ></salInsuredList>

      <!-- 发票信息 -->
      <div class="title_">
        <div class="cutleft_">开票信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row>
        <a-row>环保节约，提倡电子发票，如需纸质版本，请自行打印，系统将通过邮件及手机短信发送电子发票，请注意查收。</a-row>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 4 }" label="发票类型">
            <a-select
              placeholder="请选择"
              :disabled="userBol"
              @change="invoiceprinttypeChange"
              v-decorator="[
                'applicantInfo.invoiceprinttype',
                { rules: [{ required: true, message: '请选择' }] },
              ]"
            >
              <a-select-option value="01">暂不开票</a-select-option>
              <a-select-option value="03">电子发票</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="applicantInfo.invoiceprinttype == '03'">
          <a-form-item :label-col="{ span: 6 }" label="纳税人识别号">
            <a-input
              :disabled="userBol"
              v-model="applicantInfo.taxpayercertificateno"
              v-decorator="[
                'applicantInfo.taxpayercertificateno',
                { rules: [{ required: true, message: '请输入纳税人识别号' }] },
              ]"
              placeholder="请输入纳税人识别号"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-form-item label="保费" :label-col="{ span: 1 }">
          <a-col :span="6">
            <a-input
              v-model="applicantInfo.totalPremium"
              disabled
              style="width: 130px"
              addonAfter="元"
            />
          </a-col>
          <a-col>
            <a-button
              class="btn_color"
              type="primary"
              :disabled="userBol"
              @click="changePremium"
            >修改保费</a-button>
          </a-col>
        </a-form-item>
      </a-row>

      <a-row :gutter="24" class="btn_list" v-show="userBol">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled='!agreementAllRead' @change="onChangeyueduBtn" style="margin-bottom: 20px">
          投保人已充分阅读、理解并同意<fileView></fileView>
        </a-checkbox>
      </a-row>
      <a-row class="btn_list">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <!-- <a-button class="btn_color" type="primary" v-show="checkContent.riskNotifyFlag == '1' && disabledAll"
              @click="fileListClick">
              文件列表
            </a-button>-->
            <a-button
              class="btn_color"
              type="primary"
              :loading="submitLoad1"
              v-show="!userBol"
              @click="handleSubmitjyb('save')"
            >
              <!-- html-type="submit" -->
              保存订单
            </a-button>
            <a-button class="btn_color" type="primary" v-show="userBol" @click="goBack()">返回编辑</a-button>
            <a-button
              style="margin-left: 24px"
              class="btn_color"
              type="primary"
              v-show="userBol"
              @click="handleSubmitjyb()"
              :loading="submitLoad2"
            >立即投保</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 修改保费modal -->
    <a-modal v-model="modalVisible" title="修改保费" cancelText="取消" okText="确定" @ok="handleOk">
      <div v-for="(item, key) in copyCScontent" :key="key">
        <div v-if="key == leibie">
          请输入职业{{ key }}保费(如不输入则按原值({{
          ContentView[key]
          }})计算)：
          <a-input-number
            class="level_"
            :min="parseFloat(ContentView[key])"
            v-model="copyCScontent[key]"
          />
        </div>
      </div>
    </a-modal>
    <!-- 支付的弹窗 -->
    <a-modal
      class="myModal_"
      width="500px"
      title="支付确认"
      forceRender
      v-model="showPaySure"
      @ok="paySure"
      :afterClose="handlePayModalClose"
      okText="确定"
      cancelText="关闭"
    >
      <p
        style="
          text-align: center;
          font-size: 18px;
          margin-bottom: 0;
          padding: 20px;
          line-height: 30px;
        "
      >
        您投保的{{ productName() }}需支付保费
        <span style="color: #fe8f2d; font-weight: bold">
          {{
          applicantInfo.totalPremium
          }}
        </span>&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import Vue from 'vue'
import utils from "./../js/utils";
import moment from "moment";
import salInsuredList from "./salInsuredList";
import { policyMixin } from '@/mixins/policyMixin.js';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { salInsuredList},
  mixins: [policyMixin],
  data() {
    //这里存放数据
    return {
      leibie: "1类", //产品类别
      submitLoad1: false, //保存中
      yueduBtn: false,//阅读中
      submitLoad2: false, //提交中
      showPaySure: false, //支付
      postPolicyData: {}, //要提交的数据
      policyId: "", //支付回来的id
      checkVisible: false, //凭证支付
      showQrcodePayModal: false, // 二维码支付
      /**需要的数据开始 */
      applicantInfo: {
        name: "", //投保企业名称
        idType: "", //证件类型
        idNumber: "", //证件号码
        imageUrl: "", //证件图片
        pacCode: "", //省市区
        address: "", //详细地址
        // companyProperty: "", //企业性质
        industrycode: [], //行业类别
        contactsname: "", //联系人名称
        contactsphone: "", //联系人电话
        email: "", // 邮箱
        // beneficiary: "", // 附加被保险人
        remark: "", //备注
        invoiceprinttype: "01", //发票类型
        taxpayercertificateno: "", //纳税人识别号
        payMethod: "", //支付方式
        totalPremium: 0, //总保费
        expireDate: "",
        effectiveDate: "" //投保期限
      },
      address: "",
      //表格的头部
      columns: utils.columns,
      //表格的数据
      data: [],
      rate: 0.2, //费率
      industrycodeTEXT: "", //四级行业的文本
      maxType: 1, //最大类别
      companyCode: "01", //企业性质
      planinfos: "0;0;0", //基础保费
      perRiskInfo: "", //险种类
      evidenceNumber: "", //凭证号
      riskNumber: {}, //计算保费
      uniqueArr: [], //去重后的人数列表
      orderContent: {},
      industrycode: [], // 行业类别
      //投保人证件类型
      companyIdTypeOptions: utils.companyIdTypeOptions,
      //投保的天数
      guarantPre: [
        {
          key: 1,
          value: "1个月"
        },
        {
          key: 3,
          value: "3个月"
        },
        {
          key: 6,
          value: "6个月"
        },
        {
          key: 12,
          value: "12个月"
        }
      ],
      loading: false,
      form: this.$form.createForm(this, { name: "advanced_search" }),
      RiskInfos: {
        architecture: "0",
        riskInfos: [
          {
            riskCode: "PL180Y502",
            dutyCode: "CVYA001",
            amount: 100000,
            premiumAmt: 0,
            riskName: "意外伤害身故、残疾",
            riskAmountDesc: 100000
          }
        ],
        salPolicy: {
          productCode: "", //产品code
          bracket: 12, //保费期限
          planCode: ""
        },
        salPolicyHolder: {
          addfifty: "1", // 测算类型
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [] //人数
      }, //测算的数据
      modalVisible: false, //修改保费的弹窗
      CScontent: {},
      ContentView: {}, //展示的保费
      copyCScontent: {}, //拷贝的
      creator: "1",
      productCode: "",
      plan: "",
      userParams: "",
      /**需要的数据结束 */
      guapre: 1,
      mon: 12,
      planOffsetDay: 0,
      baodanData: {
        startdata: ""
      },
      startValues: null,
      userBol: false,
      disabledAll: false, //是否是立即投保
      linshiContent: {},
      // riskInfosAmount:{},//计算险种的结果
      typeNumObj: {
        "1类": 0,
        "2类": 0,
        "3类": 0,
        "4类": 0,
        "5类": 0
      },
      architecture: true,
      prohibitedIndustries: [
        //投保名称限制关键字
        "铁塔",
        "电梯",
        "幕墙",
        "危险品",
        "脚手架",
        "房屋",
        "拆房",
        "疏浚",
        "拆",
        "劳务",
        "钢结构",
        "人力资源",
        "职业介绍",
        "人才服务",
        "人才介绍",
        "企业咨询"
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {
    addressOptions() {
      let arr = this.$lodash.cloneDeep(window.addrescode);
      if (
        this.leibie == "3类" ||
        this.leibie == "4类" ||
        this.leibie == "5类"
      ) {
        //3-5类地区限制
        arr.forEach(elements => {
          if (elements.value == "320000") {
            elements.children.forEach(element => {
              if (element.value == "320500") {
                element.children = element.children.filter(
                  item => item.value != "320582" && item.value != "320581"
                );
              }
            });
          }
        });
      }
      if (this.industrycode[1] && this.industrycode[1] == "C21") {
        //家具制造限制
        arr.forEach(elements => {
          if (elements.value == "440000") {
            elements.children = elements.children.filter(
              item => item.value != "440700"
            );
          }
        });
      }
      return arr;
    },
    //行业类别
    industryList() {
      let arr = JSON.parse(JSON.stringify(window.industrylist));
      // E", "E48", "E489", "E4890
      let architecture = this.architecture;
      if (architecture) {
        arr.forEach(element => {
          if (element.value == "E") {
            element.children.forEach(eles => {
              if (eles.value == "E48") {
                eles.children = eles.children.filter(
                  item => item.value != "E489"
                );
              }
            });
          }
        });
      }
      return arr;
    },
    applicantInfoExpireDate() {
      let mon = this.mon;
      let date = this.applicantInfo.effectiveDate;
      let t
      if (date != "") {
       t = moment(date)
          .add(mon, "M")
          .subtract(1, "s");
      }
      return t
    }
  },
  //监控data中的数据变化
  watch: {
    "applicantInfo.pacCode"(val) {
      sessionStorage.removeItem("pacCode");
      sessionStorage.setItem("pacCode", val[2].value || null);
    },
    "applicantInfo.industrycode"(val) {
      sessionStorage.removeItem("HYCode");
      sessionStorage.setItem("HYCode", val || null);
    },
    "applicantInfo.name"(val) {
      this.prohibitedIndustries.every(element => {
        if (val.indexOf(element) != -1) {
          this.$message.error(`投保人名称包含拒保关键字，无法投保该产品！`);
          this.form.setFieldsValue({
            applicantInfo: { name: "" }
          });
          this.form2.setFieldsValue({
            name: ""
          });
          return false;
        } else {
          this.form.setFieldsValue({
            applicantInfo: {
              name: val
            }
          });
          return true;
        }
      });
      if (val.indexOf("天津") != -1) {
        this.applicantInfo.name = "";
        this.form.setFieldsValue({
          applicantInfo: {
            name: ""
          }
        });
        this.$message.warning("天津地区企业不可投保");
      }
      if (
        this.leibie == "3类" ||
        this.leibie == "4类" ||
        this.leibie == "5类"
      ) {
        if (val.indexOf("张家港") != -1 || val.indexOf("常熟") != -1) {
          this.applicantInfo.name = "";
          this.form.setFieldsValue({
            applicantInfo: {
              name: ""
            }
          });
          this.$message.warning("该投保人企业不符合投保规则, 不可投保");
        }
      }
      if (this.industrycode[1] && this.industrycode[1] == "C21") {
        if (val.indexOf("江门") != -1 || val.indexOf("新会") != -1) {
          this.applicantInfo.name = "";
          this.form.setFieldsValue({
            applicantInfo: {
              name: ""
            }
          });
          this.$message.warning("该投保人企业不符合投保规则, 不可投保");
        }
      }
    }
  },
  //方法集合
  methods: {
    moment,
    productName() {
      return sessionStorage.getItem('productName')
    },
    onChangeyueduBtn(e) {
      this.yueduBtn = e.target.checked;
    },
    goBack() {
      //返回编辑
      this.userBol = false;
      this.$bus.$emit("busUserBol", false);
      let obj = this.$route.query;
      this.$router.push({
        path: "JYBZXTY",
        query: {
          u: obj.u,
          p: obj.p,
          planCode: obj.planCode,
          sign: obj.sign
        }
      });
    },
    filterPcode(arr) {
      let str;
      if (arr&&arr.length) {
        if (isNaN(parseInt(arr[0]))) {
          str = 'text'
        }else{
          str = 'value'
        }
        if (!str) return
        try {
          var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
          var oneArr = addressOptions.filter((item) => arr[0] == item[str]) || [];
          var twoArr =
            oneArr[0].children.filter((item) => arr[1] == item[str]) || [];
          var threeArr =
            twoArr[0].children.filter((item) => item[str] == arr[2]) || [];
          sessionStorage.setItem("pacCode", threeArr[0].value);
        } catch (error) {
          throw new Error(error);
        }
        return {
          code: [oneArr[0]?oneArr[0].value:'', twoArr[0]?twoArr[0].value:'', threeArr[0]?threeArr[0].value:''],
          arrCode: [oneArr[0], twoArr[0], threeArr[0]],
        };
      }
    },
    //打开文件列表
    fileListClick() {
      this.$store.commit("setNotShow", true);
    },
    //判断是否有多种类别
    checkBaseList(list) {
      return list.filter(e => e.personNum > 0).length > 0;
    },
    queryOrderDetails() {
      // 查询保单信息
      let parms = {
        policyId: this.$route.query.policyId
      };
      this.$api.queryOrderDetails(parms).then(res => {
        if (res.data.returnCode == 0) {
          if (res.data.content) {
            this.orderContent = res.data.content;
            this.$store.commit("setOrderContent", this.orderContent);
            if (res.data.content.salInsuredList) {
              //被保人清单
              this.data = res.data.content.salInsuredList;
              this.data.forEach((element, i) => {
                let str = element.birthDate;
                element.occupation = [
                  element.occupationCode.substring(0, 3),
                  element.occupationCode.substring(0, 5),
                  element.occupationCode
                ]; //职业类别代码
                element["index"] = i + 1;
                element.birthDate =
                  str.slice(0, 4) +
                  "-" +
                  str.slice(4, 6) +
                  "-" +
                  str.slice(6, 8); //生日
              });
            }
            this.data = res.data.content.salInsuredList;
            this.perRiskInfo = res.data.content.riskInfos;
            this.riskNumber = this.countTimes(this.data);
            this.RiskInfos.premiumBaseDtoList = this.numResult(
              res.data.content.salInsuredList
            ); //人员类别，处理成每一类的人数
            this.RiskInfos.salPolicy = { ...this.RiskInfos.salPolicy, ...res.data.content.salPolicy };
            this.RiskInfos.salPolicyHolder = { ...this.RiskInfos.salPolicyHolder, ...res.data.content.salPolicyHolder };
            this.RiskInfos.salPolicyHolder.addfifty = "1";
            this.RiskInfos.riskInfos = res.data.content.riskInfos; //险种信息
            // this.resultPremiumSum(this.RiskInfos);
            if (res.data.content.riskInfos) {
              let riskInfos = res.data.content.riskInfos;
              this.$bus.$emit("busRiskInfos", this.$lodash.cloneDeep(riskInfos));
            }
            if (res.data.content.salPolicy) {
              let salPolicy = res.data.content.salPolicy;
              this.plan = salPolicy.planCode;
              this.mon = parseInt(salPolicy.bracket);
              this.applicantInfo.mon = parseInt(salPolicy.bracket);
              this.applicantInfo.totalPremium = salPolicy.totalPremium;
              this.applicantInfo.payMethod = salPolicy.payMethod;
              this.creator = salPolicy.creator;
              this.productCode = salPolicy.productCode;
              let effectiveDate;
              if (this.$route.query.xb) {
                //续保情况下时间处理
                effectiveDate = moment(salPolicy.expireDate).add(1, "days");
              } else {
                effectiveDate = moment(salPolicy.effectiveDate);
              }
              this.applicantInfo.effectiveDate = moment(effectiveDate).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              this.baodanData.startdata = this.applicantInfo.effectiveDate;
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicy,
                  effectiveDate: moment(effectiveDate).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                },
                baodanData: {
                  startdata: moment(effectiveDate).format("YYYY-MM-DD")
                }
              });
            }

            if (res.data.content.salPolicyHolder) {
              let salPolicyHolder = res.data.content.salPolicyHolder;
              this.$bus.$emit("busStature", salPolicyHolder.stature), //"是否高空，是：1，否：2，默认2"
                (this.applicantInfo.name =
                  res.data.content.salPolicyHolder.name);
              this.applicantInfo.pacCode = this.filterPcode(
                [
                  salPolicyHolder.province,
                  salPolicyHolder.city,
                  salPolicyHolder.district
                ] || []
              ).arrCode;
              this.address = salPolicyHolder.address;
              sessionStorage.setItem("HYCode", salPolicyHolder.industrycode);
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicyHolder,
                  industrycode: [
                    salPolicyHolder.industrycode.slice(0, 1),
                    salPolicyHolder.industrycode.slice(0, 3),
                    salPolicyHolder.industrycode.slice(0, 5),
                    salPolicyHolder.industrycode
                  ],
                  // ["110000", "110100", "110101"]
                  pacCode: this.filterPcode(
                    [
                      salPolicyHolder.province,
                      salPolicyHolder.city,
                      salPolicyHolder.district
                    ] || []
                  ).code
                }
              });
            }
            // debugger
          }
        }
      });
    },
    emailChange(e) {
      let val = e.target.value;
      if (!this.$checkEmail.test(val)) {
        this.form.setFieldsValue({
          applicantInfo: {
            email: ""
          }
        });
        this.$message.error("请输入正确的联系人邮箱", 3);
      }
    },
    idPhoneChange(e) {
      let val = e.target.value;
      if (!this.$checkPhone.test(val)) {
        this.form.setFieldsValue({
          applicantInfo: {
            contactsphone: ""
          }
        });
        this.$message.error("请输入正确的联系人手机号", 3);
      }
    },
    //确认修改
    handleOk() {
      let numResult = 0;
      let sumZfeiyong = utils.sumZfeiyong(this.copyCScontent, this.riskNumber);
      Object.values(sumZfeiyong).forEach(e => {
        numResult += e;
      });
      this.applicantInfo.totalPremium = numResult.toFixed(2);
      this.CScontent = this.copyCScontent;
      console.log(this.copyCScontent, "修改后的保费");

      this.modalVisible = false;
    },
    //修改保费
    changePremium() {
      if (JSON.stringify(this.CScontent) == "{}") {
        this.$message.error("您还没有计算保费");
        return;
      }
      this.modalVisible = true;
    },
    //统计次数
    numResult(data) {
      // debugger
      var d = [];
      var b = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
      };
      data.forEach(e => {
        let levelF = Number(e.occulevel.toString().slice(0, 1));
        if (b[levelF] !== undefined) {
          b[levelF] += 1;
        }
      });
      for (const key in b) {
        var c = {
          occupationKind: "",
          personNum: 0
        };
        c.occupationKind = key;
        c.personNum = b[key];
        d.push(c);
      }
      return d;
    },
    getterData(data) {
      // debugger
      let gerdata = [];
      data.forEach(e => {
        let strArr = [
          e.name,
          utils.getterIdtype(e.idType),
          e.idNumber,
          e.birthDate,
          utils.getterGender(e.gender),
          e.occupationCode,
          '',
          '',
          e.occupationName,
          '',
          1,
          '',
          e.occulevel.toString().slice(0, 1)
        ];
        gerdata.push(strArr.join(","));
      });
      return gerdata.join(";");
    },
    filter(inputValue, path) {
      return path.some(option => {
        return option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    //测算的总价格
    cesuannum(data) {
      var a = {};
      var resultnum = 0;
      this.RiskInfos.premiumBaseDtoList.forEach(e => {
        let occupationKind = e.occupationKind.toString().slice(0, 1) + "类";
        a[occupationKind] = e.personNum;
      });
      this.typeNumObj = this.$lodash.cloneDeep(a);
      // debugger
      for (const key in a) {
        resultnum += a[key] * data[key];
      }
      console.log(resultnum, "总保费");
      return resultnum.toFixed(2);
    },
    //试算的接口
    resultPremiumSum(data) {
      // return
      let copyData = this.$lodash.cloneDeep(data);
      copyData.premiumBaseDtoList.forEach(e => {
        e.occupationKind = e.occupationKind.toString().slice(0, 1) + "类";
      });
      let formData = {
        architecture: copyData.architecture,
        riskInfos: copyData.riskInfos, //险种信息
        // riskInfos: copyData.riskInfos.filter((item) => item.amount > 0),//险种信息
        salPolicy: {
          planCode: this.plan, //产品计划 （固定值ConstructAccident）
          productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
          creator: this.creator,
          bracket: copyData.salPolicy.bracket //保费期限
        },
        salPolicyHolder: {
          addfifty: "1", // 测算类型
          stature: copyData.salPolicyHolder.stature, //是否高空（2-否，1-是）
          name: this.applicantInfo.name
        },
        salPolicyExt: {
          isworkheightinvolved: copyData.salPolicyHolder.stature,
          occEmpVersion:this.fileCodeContent.id
        },
        premiumBaseDtoList: copyData.premiumBaseDtoList, //人数
      };
      // return
      this.$api.calPremiumEmployer(formData).then(res => {
        if (res.data.success) {
          let datas = res.data.content;
          this.CScontent = datas;
          this.perRiskInfo = this.$lodash.cloneDeep(datas.perRiskInfo);
          delete datas["perRiskInfo"];
          this.ContentView = this.$lodash.cloneDeep(datas); //恒定不变的展示用，做限制
          this.copyCScontent = utils.resoverObj(this.$lodash.cloneDeep(datas)); //计算用的改变的数据
          this.applicantInfo.totalPremium = this.cesuannum(datas); //总保费
          this.sumrate(
            this.RiskInfos.salPolicyHolder.stature,
            this.data,
            this.RiskInfos.salPolicy.bracket
          );
        } else {
          this.$message.error(res.data.returnMsg + "错误");
        }
      });
    },
    invoiceprinttypeChange(value) {
      //发票类型更改
      this.applicantInfo.invoiceprinttype = value;
    },
    //选择天数的
    onChangemon(e) {
      this.mon = e.target.value;
      this.RiskInfos.salPolicy.bracket = this.mon;
      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
      if (this.applicantInfo.effectiveDate) {
        let end = moment(this.startValues)
          .add(this.mon, "month")
          .subtract(1, "days");
        let offsetDay = end.diff(this.startValues, "days") + 1;
        this.planOffsetDay = offsetDay;
        this.form.setFieldsValue({ expireDate: end });
      }
    },
    //处理时间的
    effectiveDateChange(date1, date) {
      this.applicantInfo.effectiveDate = date;
    },
    //开始时间
    disabledDate(current) {
      var dd = new Date();
      dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      var time = y + "-" + m + "-" + d;
      var currents = moment(time);
      return current && current < currents;
    },
    //修改
    EduitSelect(data) {
      console.log(data, "传过来的数据");
      this.data.forEach((e, i) => {
        if (e.index == data.index) {
          this.data[i] = data;
        }
        if (e.occulevel.toString().indexOf("类") <= -1) {
          e.occulevel = e.occulevel + "类";
        }
      });
      this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
      this.riskNumber = this.countTimes(this.data);
      console.log(this.riskNumber, "人数");
      this.resultPremiumSum(this.RiskInfos);
    },
    //粘贴
    addSelectpre(data) {
      if (Array.isArray(data)) {
        this.data.push(...data);
      } else {
        this.data.push(data);
      }
      let cesiData = this.$lodash.cloneDeep(this.data);
      this.data = utils.unique(this.data, "idNumber");
      if (cesiData.length != this.data.length) {
        this.$message.warning("受保人有重复，已做删除");
      }
      this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
      this.riskNumber = this.countTimes(this.data);
      this.resultPremiumSum(this.RiskInfos);
    },
    //批量删除
    delSelectpre(data) {
      this.data = data;
      let cesiData = this.$lodash.cloneDeep(this.data);
      this.data = utils.unique(this.data, "idNumber");
      if (cesiData.length != this.data.length) {
        this.$message.warning("受保人有重复，已做删除");
      }
      this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
      this.riskNumber = this.countTimes(this.data);
      if (this.data.length) {
        this.resultPremiumSum(this.RiskInfos);
      } else {
        this.applicantInfo.totalPremium = 0;
      }
    },
    filterSalInsuredList(data) {
      return data.filter(e => {
        delete e["occupation"];
        delete e["mobile"];
        delete e["termOfValidity"];
        delete e["uniqueid"];
        delete e["type"];
        delete e["height"];
        switch (e["gender"]) {
          case "男":
            e["gender"] = "M";
            break;
          case "女":
            e["gender"] = "F";
            break;
        }
        e["occulevel"] =
          e.occulevel.toString().indexOf("类") > -1
            ? e.occulevel.toString()
            : e.occulevel.toString() + "类";
        return e.occulevel;
      });
    },
    //计算总保费
    countTimes(data) {
      var a = [];
      if (data.length) {
        data.forEach(e => {
          let leve =
            e.occulevel.toString().indexOf("类") > -1
              ? e.occulevel.toString()
              : e.occulevel.toString() + "类";
          a.push(leve);
        });
        return a.reduce(function(time, name) {
          if (name in time) {
            time[name]++;
          } else {
            time[name] = 1;
          }
          return time;
        }, {});
      } else {
        return {
          "1类": 0,
          "2类": 0,
          "3类": 0,
          "4类": 0,
          "5类": 0
        };
      }
    },
    //计算费率
    sumrate(isHighWork, data, bracket) {
      console.log(bracket, "期限");
      var a = [];
      data.forEach(e => {
        a.push(e.occulevel.slice(0, 1));
      });
      this.maxType = Math.max(...a);
      var is45 = a.some(val => {
        return val == "4" || val == "5";
      });
      if (is45 || isHighWork == "1") {
        let rate = {
          1: 0.4,
          3: 0.4,
          6: 0.7,
          12: 1.0
        };
        this.rate = rate[bracket];
      } else {
        let rate = {
          1: 0.2,
          3: 0.4,
          6: 0.7,
          12: 1.0
        };
        this.rate = rate[bracket];
      }
    },
    //拼接gztypestr字段
    gztypestrPin() {
      var a = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
      };
      // delete this.CScontent["perRiskInfo"];
      for (const key in this.CScontent) {
        a[key] = this.CScontent[key];
      }
      let baofei = Object.values(a).join(";"); //总保费
      this.planinfos = Object.values(a)
        .slice(0, 3)
        .join(";"); //基础保费
      console.log(baofei, "===========总保费");
      var arr = [
        this.RiskInfos.salPolicyHolder.stature || 2,
        this.RiskInfos.salPolicy.bracket || 1,
        this.maxType,
        this.rate || 0.2,
        this.industrycodeTEXT || "",
        this.applicantInfo.industrycode[3] || "",
        // this.applicantInfo.companyProperty || "01",
        this.data.length || 0,
        baofei
      ];
      console.log(arr, "拼接的字符串");
      return arr.join(";");
    },
    //最后的提交
    handleSubmitjyb(type) {
      console.log(this.data, "data需要提交的数据");
      // e && e.preventDefault();
      let ageStatus = true;
      this.data.forEach(e => {
        let age = moment().diff(e.birthDate, "years");
        if (age < 16 || age > 65) {
          this.$message.error("投保人年龄仅限于16-65周岁，请修改后再试！");
          ageStatus = false;
          return;
        }
      });
      if (!ageStatus) {
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          if (type == "save") {
            //保存
            this.submitLoad1 = true;
            // console.log("Received values of form: ", values, err);
            let base = this.applicantInfo;
            let one = this.RiskInfos.premiumBaseDtoList[2].personNum;
            let two = this.RiskInfos.premiumBaseDtoList[3].personNum;
            let stree = this.RiskInfos.premiumBaseDtoList[4].personNum;
            if (this.RiskInfos.premiumBaseDtoList.length < 3) {
              this.$message.warning(
                "投保人须为团体，每张保单不少于3人投保，且需投保同一方案。"
              );
              return;
            }
            let copyRiskInfos = this.RiskInfos.premiumBaseDtoList.filter(
              item => item.personNum > 0
            );
            if (copyRiskInfos.length > 1) {
              this.$message.warning(
                "不同职业类别需拆单投保，且需投保同一方案。"
              );
              return;
            }
            let num45 = Number(two)+Number(stree)
              if (this.leibie == "4类" || this.leibie == "5类") {
                if (num45<10) {
                  this.$message.warning(
                    "4-5类职业最低投保人数最低10人。"
                  );
                  return
                }
              }
            if (
              values.applicantInfo.pacCode[2].value == "320582" ||
              values.applicantInfo.pacCode[2].value == "320581"
            ) {
              
              if (one || two || stree) {
                this.$message.error("当前地区仅限于投保1-2类职业");
                return;
              }
            }
            let riskInfos =
              this.RiskInfos &&
              this.RiskInfos.riskInfos.filter(item => item.amount != 0);

            let data = {
              salInsuredList: this.filterSalInsuredList(this.data), //表格的数据
              salPolicy: {
                //保单信息
                planCode: this.plan, //产品计划 （固定值ConstructAccident）
                productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
                creator: this.creator,
                id: this.policyId,
                // issueDate: moment().format("YYYY-MM-DD HH:mm:ss"), //applyTime  投保时间（当前时间）
                effectiveDate: moment(values.baodanData.startdata).format(
                  "YYYY-MM-DD"
                ), //startTime  保单生效时间
                expireDate: moment(this.applicantInfoExpireDate).format(
                  "YYYY-MM-DD"
                ), //endTime   保单终止时间
                payMethod: values.applicantInfo.payMethod, //支付方式”
                bracket: this.RiskInfos.salPolicy.bracket, //页面选择的保障期间（几个月就传几，整数）
                totalPremium: base.totalPremium, //totalPremium  总保费
                juvenilesAvgpremuim: this.copyCScontent[this.leibie], //修改后的保费
                coverageamount: "", //totalSumInsured  总保额
                remark: values.applicantInfo.remark, //备注
                ordertraceno: "" //"凭证支付时的凭证号",
              },
              salPolicyHolder: {
                //投保人信息
                riskDutyInfo: utils.perRiskInfoNew(this.perRiskInfo), //  /**另加 */
                bAppList: this.getterData(this.data) /**另加 */,
                addfifty: "2", //测算类型
                type: "C", //固定值
                schooltype:
                  this.RiskInfos.salPolicyHolder.stature == "1" ? "Y" : "N",
                name: values.applicantInfo.name, //name  投保人名称
                idType: values.applicantInfo.idType, //证件类型
                idNumber: values.applicantInfo.idNumber, //certNo   证件号码
                address: values.applicantInfo.address, //详细地址
                contactsname: values.applicantInfo.contactsname, //联系人姓名
                contactsphone: values.applicantInfo.contactsphone, //联系人电话
                email: values.applicantInfo.email, //联系人邮箱
                industrycode: values.applicantInfo.industrycode[3], //行业类型
                pacCode: values.applicantInfo.pacCode, //地区code
                province: base.pacCode[0].text, //省
                city: base.pacCode[1].text, //市
                district: base.pacCode[2].text, //区
                addresscode:`${base.pacCode[0].value}-${base.pacCode[1].value}-${base.pacCode[2].value}`,
                stature: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
                invoiceprinttype: values.applicantInfo.invoiceprinttype, //"发票类型，电子普通发票：01、暂不开票：03",
                taxpayercertificatetype:
                  values.applicantInfo.invoiceprinttype == "01"
                    ? values.applicantInfo.taxpayercertificateno
                    : "01"
              },
              salPolicyHolderExt:{
                industryname:this.industrycodeTEXT,
              },
              salPolicyExt: {
                occEmpVersion:this.fileCodeContent.id,
                isworkheightinvolved: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
                architecture: this.RiskInfos.architecture // 是否是建筑行业
              },
              riskInfos: riskInfos
            };
            this.postPolicyData = data;
            // return
            if (this.$route.query.policyId) {
              this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
            }
            this.axiosPolicy("save"); // 保存订单是 直接保存
          } else {
            if (!this.yueduBtn) {
              this.$message.warning(
                "请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》",
                2
              );
              return;
            }
            this.submitLoad2 = true;
            this.showPaySure = true;
          }
        } else {
          this.$message.error("请填写完整提交的数据");
        }
      });
    },
    axiosPolicy(save) {
      //提交保单
      if (save == "save") {
        this.$api
          .addPAPolicy(this.postPolicyData)
          .then(res => {
            if (res.data.returnCode == "00") {
              this.showPaySure = false;
              this.policyId = res.data.content;
              this.$message.success("保存成功！");
              this.$router.push({
                name: "JYBZXTY",
                query: {
                  u: this.$route.query.u,
                  p: this.$route.query.p,
                  planCode: this.$route.query.planCode,
                  sign: this.$route.query.sign,
                  policyId: this.policyId
                }
              });
              this.disabledAll = true;
              this.$bus.$emit('disabledBus', true);
            }
          })
          .finally(() => {
            this.submitLoad1 = false;
          });
      }
    },
    paySure() {
      //支付确认
      console.log(this.postPolicyData, "====this.postPolicyData");
      //支付确认
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
      this.policyId = this.$route.query.policyId;
      this.$payModal({
        show: true,
        type: "jybzxty", //产品类型
        policyId: this.policyId, //产品id
        creator: this.creator, //用户id
        payMethod: this.applicantInfo.payMethod, //支付方式
        productCode: this.$route.query.p, //产品code
        totalPremium: this.applicantInfo.totalPremium, //支付总金额
        name: this.applicantInfo.name,
      });
    },
    handlePayModalClose() {
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
    },
    handleChange(value, type, label) {
      if (type == "pacCode") {
        this.applicantInfo[type] = label;
        this.address =
          label.length > 2 ? label[0].text + label[1].text + label[2].text : "";
        sessionStorage.setItem("pacCode", value[2]);
      } else if (type == "industrycode") {
        sessionStorage.setItem("HYCode", value);
        this.industrycodeTEXT = label ? label[3].text : "";
        console.log(this.industrycodeTEXT)
        this.applicantInfo[type] = value;
        this.industrycode = value; //行业类型
        if (value[1] == "C21") {
          //家具制造业 限制地区
          let name = this.applicantInfo.name;
          if (name.indexOf("江门") != -1 || name.indexOf("新会") != -1) {
            this.applicantInfo.name = "";
            this.form.setFieldsValue({
              applicantInfo: {
                name: ""
              }
            });
            // this.$message.warning("该投保人企业不符合投保规则, 不可投保");
            this.$message.warning("此地区不可投保家具制造业");
          }
        }
      } else {
        this.applicantInfo[type] = value;
      }
      if(type == 'idType') {
        this.queryCompanyCodeByName()
      }
    },
    queryCompanyCodeByName() {
      if(this.applicantInfo.idType !== '01' && this.applicantInfo.idType !== '04') {
        this.form.setFieldsValue({
          applicantInfo: {
            idNumber: ''
          }
        })
        this.applicantInfo.idNumber = ''
        return
      }
      let type = this.applicantInfo.idType == '01' ? 2 : 1
      this.blurCompanyName(type)
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const { u, p, planCode } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    if (planCode) {
      this.leibie =
        parseFloat(planCode.split("jybzxttyw")[1]).toString() + "类";
    } else {
      this.leibie = "1类";
    }
    this.plan = planCode;
    this.userParams = {
      //从地址中获取
      userId: u,
      planCode: planCode,
      productCode: p
    };
    if (this.$route.query.policyId) {
      this.queryOrderDetails();
      this.userBol = true;
    } else {
      this.userBol = false;
    }
    if (this.$route.query.xb) {
      this.userBol = false;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (this.$route.query.policyId) {
      //用户访问页面 取消操作权限
    }
    this.$bus.$on("onRiskInfos", data => {
      let strdata = this.$lodash.cloneDeep(data);
      this.RiskInfos.architecture = strdata.architecture;
      this.RiskInfos.riskInfos = strdata.riskInfos;
      this.RiskInfos.salPolicy = strdata.salPolicy;
      this.RiskInfos.salPolicyHolder = strdata.salPolicyHolder;
      this.mon = Number(strdata.salPolicy.bracket);
      this.form.setFieldsValue({
        applicantInfo: {
          name: strdata.salPolicyHolder.name
        }
      });
      console.log(this.RiskInfos, "接受到的数据");
      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
      if (this.RiskInfos.architecture == "1") {
        this.architecture = false;
        this.form.setFieldsValue({
          applicantInfo: {
            industrycode: ["E", "E48", "E489", "E4890"]
          }
        });
      } else {
        this.architecture = true; //其他行业 去除建筑类
      }
    });
  },
  beforeDestroy() {
    this.$bus.$off("onRiskInfos");
    this.$bus.$off("CScontent");
  } //生命周期 - 销毁之前
};
</script>
<style lang="scss">
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}

.avatar-uploader >>> .ant-upload img {
  width: 100%;
  height: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.btn_color {
  margin: 0 20px;
}

.user {
  .ant-select,
  .ant-calendar-picker,
  .ant-cascader-picker {
    pointer-events: none !important;
  }

  #myCal {
    pointer-events: none !important;
  }
}
</style>